import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import ReactDOM from "react-dom";
import "./Navbar.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const alwaysDark = location.pathname !== "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/product", label: "Product" },
    { to: "/catalogue", label: "Catalogue" },
    { to: "/client", label: "Clients" },
    { to: "/contact", label: "Contact Us" },
  ];

  return (
    <>
      {/* ← backdrop rendered directly into document.body via portal */}
      {menuOpen &&
        ReactDOM.createPortal(
          <div
            className="navbar__backdrop"
            onClick={() => setMenuOpen(false)}
          />,
          document.body,
        )}

      <nav
        className={`navbar ${scrolled || alwaysDark ? "navbar--scrolled" : ""}`}
      >
        <div className="navbar__container">
          <Link to="/" className="navbar__logo">
            <span className="navbar__logo-text">RK Overseas</span>
            <span className="navbar__logo-sub">Est. 1997</span>
          </Link>

          <button
            className={`navbar__hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul
            className={`navbar__links ${menuOpen ? "navbar__links--open" : ""}`}
          >
            <li className="navbar__close-item">
              <button
                className="navbar__close-btn"
                onClick={() => setMenuOpen(false)}
                aria-label="Close navigation menu"
              >
                ✕
              </button>
            </li>
            {navLinks.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  end={to === "/"}
                  className={({ isActive }) =>
                    `navbar__link ${isActive ? "active" : ""}`
                  }
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
